import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export interface BatchRecalculateCellsRequest {
  cell_ids: string[];
}

export interface BatchRecalculateCellsResponse {
  success?: boolean;
  execution_id?: string;
  target_execution_id?: string;
  cell_count?: number;
  selected_cell_count?: number;
}

export const useBatchRecalculateCells = () => {
  const userToken = useAuth()?.userToken ?? "";
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const wid = Number(workspaceId);

  return useMutation<
    BatchRecalculateCellsResponse,
    unknown,
    { tableId: string; sheetId: string } & BatchRecalculateCellsRequest
  >({
    mutationFn: async ({ tableId, sheetId, ...payload }) => {
      const response = await fetch(
        ENDPOINTS.smart_table_cells_batch_recalculate(wid, tableId, sheetId),
        {
          method: "POST",
          headers: jsonAuthHeaders(userToken),
          body: JSON.stringify(payload),
        },
      );
      return handleResponse(response);
    },
  });
};
